// LuxeNova translation dictionaries. Add a new locale by copying `en` and translating values.

export const translations = {
    en: {
        nav: {
            home: "Home",
            property: "Property",
            concierge: "Concierge",
            events: "Events",
            journal: "Journal",
            booking: "Consultation",
            contact: "Contact",
            enquire: "Enquire",
        },
        hero: {
            eyebrow: "Warsaw · Kraków · Global Property Network",
            title_a: "Luxury Property, Concierge",
            title_highlight: "& Events",
            title_b: "",
            subheadline:
                "An international property consultancy across six markets — Poland, UAE, Georgia, Northern Cyprus, Bali and Maldives — paired with a premium concierge & events atelier proudly rooted in Poland.",
            cta_primary: "Contact Us",
            cta_secondary: "Explore Services",
        },
        about: {
            eyebrow: "About — LuxeNova",
            title_a: "Warsaw & Kraków.",
            title_b: "Six markets served.",
            p1_before: "LuxeNova is a premium lifestyle house with home bases in Warsaw and Kraków. We specialise in three disciplines — ",
            p1_and: " and ",
            p1_after: ".",
            p2: "Our property consultancy operates internationally across Poland, the UAE, Georgia, Northern Cyprus, Bali and Maldives. Our concierge and events ateliers remain proudly Polish — designed for international clients relocating, investing or celebrating between Warsaw and Kraków.",
            core: {
                property_label: "Property",
                property_sub: "International · 6 markets",
                concierge_label: "Concierge",
                concierge_sub: "Poland · Relocation · Lifestyle",
                events_label: "Events",
                events_sub: "Poland · Weddings · Galas",
            },
        },
        services: {
            eyebrow: "Our Services",
            title_a: "One house,",
            title_highlight: "three disciplines.",
            subtitle:
                "An international property consultancy paired with concierge and events ateliers proudly based in Poland.",
            cta_consult: "Request a consultation →",
            property: {
                eyebrow: "01 — Real Estate",
                title: "Property",
                blurb:
                    "A cross-border consultancy sourcing residential and commercial addresses across Poland, the UAE, Georgia, Northern Cyprus, Bali and Maldives — with property care available in our Polish markets.",
                items: [
                    "Residential & Commercial Property Sales — all six markets",
                    "Residential & Commercial Property Rentals — all six markets",
                    "Property Cleaning — Poland",
                    "Property Maintenance — Poland",
                ],
            },
            concierge: {
                eyebrow: "02 — Lifestyle · Poland",
                title: "Concierge",
                blurb: "A single point of contact for the details that matter — from your relocation to Poland to your dinner reservation tonight in Warsaw or Kraków.",
                items: [
                    "Relocation Assistance",
                    "Hotel Bookings",
                    "Restaurant Reservations",
                    "Attraction Bookings",
                    "Transportation Arrangements",
                ],
            },
            events: {
                eyebrow: "03 — Occasions · Poland",
                title: "Events",
                blurb: "Weddings under Wawel's silhouette, corporate galas in Warsaw, and private celebrations across Poland — designed, produced and remembered.",
                items: [
                    "Corporate Events",
                    "Team Building",
                    "Gala Dinners",
                    "Weddings",
                    "Private Parties",
                ],
            },
        },
        markets: {
            eyebrow: "Global Property Markets",
            title_a: "Six markets,",
            title_highlight: "one advisor.",
            subtitle: "A curated property mandate across Europe, the Gulf, South-East Asia and the Indian Ocean.",
            cta: "Request a consultation",
            service_labels: {
                sales: "Sales",
                rentals: "Rentals",
                cleaning: "Cleaning",
                maintenance: "Maintenance",
            },
            countries: {
                poland: {
                    name: "Poland",
                    tag: "Home market",
                    blurb: "Boutique flats in Kraków's Old Town, prime Warsaw addresses and heritage commercial assets — with in-house cleaning and maintenance for every property we place.",
                },
                uae: {
                    name: "United Arab Emirates",
                    tag: "Dubai · Abu Dhabi",
                    blurb: "Sky-touching residences and off-market villas in Dubai, Palm Jumeirah and Abu Dhabi — sourced through discreet international channels.",
                },
                georgia: {
                    name: "Georgia",
                    tag: "Tbilisi · Batumi",
                    blurb: "Emerging high-yield residential and short-stay opportunities on the Black Sea coast and in Tbilisi's historic quarters.",
                },
                cyprus: {
                    name: "Northern Cyprus",
                    tag: "Kyrenia · Famagusta · Edremit",
                    blurb: "Sea-view residences and beachfront developments with attractive entry points and lifestyle-led returns.",
                },
                bali: {
                    name: "Bali",
                    tag: "Canggu · Ubud · Bukit",
                    blurb: "Design-led villas and boutique investment leases across Bali's most sought-after enclaves — from surf to jungle.",
                },
                maldives: {
                    name: "Maldives",
                    tag: "Thulusdhoo",
                    blurb: "Private-island residences and branded overwater investments in a market defined by scarcity and prestige.",
                },
            },
        },
        why: {
            eyebrow: "Why LuxeNova",
            title_a: "The details,",
            title_highlight: "handled.",
            pillars: [
                { title: "Premium Service", desc: "White-glove attention on every request, every detail." },
                { title: "Trusted Local Expertise", desc: "Deep networks across Poland and our six international markets." },
                { title: "Personalised Solutions", desc: "Tailored to your family, business or occasion." },
                { title: "Fast Communication", desc: "Direct WhatsApp access to your dedicated advisor." },
                { title: "International Client Focus", desc: "Fluent in the expectations of global clientele." },
                { title: "Luxury Experience", desc: "A calm, considered, editorial standard — end to end." },
            ],
        },
        contact: {
            eyebrow: "Contact",
            title_a: "Begin the",
            title_highlight: "conversation.",
            subtitle: "A single point of contact — replies typically within the hour, in English or Polish.",
            form_eyebrow: "Enquiry Form",
            form_title: "Tell us about your plans.",
            form_subtitle: "Share a few details and we'll respond personally — never with a generic template.",
            cards: { phone: "Phone", whatsapp: "WhatsApp", instagram: "Instagram", facebook: "Facebook", email: "Email", website: "Website" },
            fields: { name: "Full Name", email: "Email", phone: "Phone Number", service: "Service Required", country: "Country / Region of Interest", description: "Description" },
            placeholders: {
                name: "Anna Kowalska",
                email: "you@example.com",
                phone: "+48 ...",
                service: "Select a service",
                country: "Select a country",
                description: "A few words about your requirement — dates, location, budget range if relevant.",
            },
            options: { property: "Property", concierge: "Concierge", events: "Events" },
            submit: "Send Enquiry",
            submitting: "Sending",
            disclaimer: "By submitting, you agree to be contacted by LuxeNova.",
            open: "Open",
            toast: {
                success_title: "Thank you",
                success_body: "Your enquiry has been received — a LuxeNova advisor will be in touch within the hour.",
                fill: "Please complete all required fields.",
                rate_limit: "You've reached the enquiry limit. Please reach us on WhatsApp: +48 576 489 912.",
                error: "Something went wrong. Please try WhatsApp.",
            },
        },
        footer: {
            tagline: "Property · Concierge · Events",
            discover: "Discover",
            rights: "All rights reserved.",
            crafted: "Crafted in Kraków",
            base: "Home bases · Warsaw · Kraków, Poland",
        },
        booking: {
            eyebrow: "Online Consultation",
            title_a: "Reserve a private",
            title_highlight: "consultation.",
            subtitle: "Book a complimentary 30-minute online consultation with a LuxeNova advisor — property across our six markets, or concierge and events in Poland.",
            pick_date: "Choose a date",
            pick_slot: "Choose a time",
            loading_slots: "Checking availability…",
            no_slots: "No slots available on this date — please choose another day.",
            video_note: "Consultations are held online via video call. Your advisor will confirm and send a meeting link by email.",
            fields: {
                name: "Full Name",
                email: "Email",
                phone: "Phone Number",
                type: "Consultation Type",
                market: "Market of Interest",
                market_any: "Not sure yet / multiple markets",
                notes: "Notes",
            },
            placeholders: { notes: "Anything that helps us prepare — budget range, timeline, occasion…" },
            types: { property: "Property", concierge: "Concierge", events: "Events" },
            submit: "Book Consultation",
            submitting: "Booking…",
            select_hint: "Select a date and time to continue.",
            disclaimer: "Complimentary & without obligation. By booking, you agree to be contacted by LuxeNova.",
            toast: {
                success_title: "Consultation booked",
                success_body: "Check your inbox — a LuxeNova advisor will confirm your session and send a meeting link.",
                fill: "Please provide your name, email and select a time slot.",
                taken: "That slot was just taken — please pick another time.",
                rate_limit: "Too many requests. Please reach us on WhatsApp: +48 576 489 912.",
                error: "Something went wrong. Please try again or contact us on WhatsApp.",
            },
        },
        chatbot: {
            title: "LuxeNova Concierge",
            status: "AI · Online",
            welcome:
                "Welcome to LuxeNova. I'm your AI concierge — ask about property across our six markets (Poland, UAE, Georgia, Northern Cyprus, Bali, Maldives), or about concierge and events in Warsaw & Kraków.",
            placeholder: "Ask the concierge…",
            suggestions: [
                "Show me property options in Dubai",
                "Plan a private gala in Warsaw",
                "Help me relocate to Kraków",
            ],
            error: "Sorry — our concierge line is briefly unavailable. Please try WhatsApp.",
        },
        blog: {
            nav_back: "← Back",
            title: "The LuxeNova Journal",
            subtitle:
                "Editorial on luxury real estate across our six markets, concierge lifestyle, and events in Warsaw & Kraków.",
            search_placeholder: "Search articles…",
            all: "All",
            read_more: "Read article →",
            read_time: "min read",
            empty: "No articles yet. Please check back soon.",
            published: "Published",
            by: "By",
            back_home: "Return to LuxeNova",
        },
        lang: { en: "English", pl: "Polski" },
    },
    pl: {
        nav: {
            home: "Start",
            property: "Nieruchomości",
            concierge: "Concierge",
            events: "Wydarzenia",
            journal: "Dziennik",
            booking: "Konsultacja",
            contact: "Kontakt",
            enquire: "Zapytanie",
        },
        hero: {
            eyebrow: "Warszawa · Kraków · Globalna sieć nieruchomości",
            title_a: "Luksusowe nieruchomości, concierge",
            title_highlight: "i wydarzenia",
            title_b: "",
            subheadline:
                "Międzynarodowe doradztwo nieruchomościowe na sześciu rynkach — Polska, ZEA, Gruzja, Cypr Północny, Bali i Malediwy — połączone z butikiem concierge i wydarzeń z dumnymi korzeniami w Polsce.",
            cta_primary: "Kontakt",
            cta_secondary: "Nasze usługi",
        },
        about: {
            eyebrow: "O nas — LuxeNova",
            title_a: "Warszawa i Kraków.",
            title_b: "Sześć rynków.",
            p1_before: "LuxeNova to premium marka lifestyle z siedzibami w Warszawie i Krakowie. Specjalizujemy się w trzech obszarach — ",
            p1_and: " oraz ",
            p1_after: ".",
            p2: "Nasze doradztwo nieruchomościowe działa międzynarodowo — Polska, ZEA, Gruzja, Cypr Północny, Bali i Malediwy. Nasze atelier concierge i wydarzeń pozostają z dumą polskie — zaprojektowane dla międzynarodowych klientów przenoszących się, inwestujących lub świętujących między Warszawą a Krakowem.",
            core: {
                property_label: "Nieruchomości",
                property_sub: "Międzynarodowo · 6 rynków",
                concierge_label: "Concierge",
                concierge_sub: "Polska · Relokacja · Lifestyle",
                events_label: "Wydarzenia",
                events_sub: "Polska · Śluby · Gale",
            },
        },
        services: {
            eyebrow: "Nasze usługi",
            title_a: "Jeden dom,",
            title_highlight: "trzy dyscypliny.",
            subtitle:
                "Międzynarodowe doradztwo nieruchomościowe połączone z atelier concierge i wydarzeń z siedzibami w Polsce.",
            cta_consult: "Umów konsultację →",
            property: {
                eyebrow: "01 — Nieruchomości",
                title: "Nieruchomości",
                blurb:
                    "Międzynarodowe doradztwo obejmujące adresy mieszkalne i komercyjne w Polsce, ZEA, Gruzji, na Cyprze Północnym, Bali i Malediwach — z pełną opieką nad nieruchomością dostępną na rynkach polskich.",
                items: [
                    "Sprzedaż nieruchomości mieszkaniowych i komercyjnych — wszystkie 6 rynków",
                    "Najem nieruchomości mieszkaniowych i komercyjnych — wszystkie 6 rynków",
                    "Sprzątanie nieruchomości — Polska",
                    "Utrzymanie nieruchomości — Polska",
                ],
            },
            concierge: {
                eyebrow: "02 — Lifestyle · Polska",
                title: "Concierge",
                blurb: "Jeden punkt kontaktowy dla wszystkich detali — od relokacji do Polski po rezerwację kolacji dziś wieczorem w Warszawie lub Krakowie.",
                items: [
                    "Pomoc w relokacji",
                    "Rezerwacje hoteli",
                    "Rezerwacje restauracji",
                    "Rezerwacje atrakcji",
                    "Organizacja transportu",
                ],
            },
            events: {
                eyebrow: "03 — Okazje · Polska",
                title: "Wydarzenia",
                blurb: "Śluby w cieniu Wawelu, gale firmowe w Warszawie i prywatne uroczystości w całej Polsce — zaprojektowane, wyprodukowane i zapamiętane.",
                items: [
                    "Wydarzenia firmowe",
                    "Team building",
                    "Kolacje galowe",
                    "Śluby",
                    "Imprezy prywatne",
                ],
            },
        },
        markets: {
            eyebrow: "Globalne rynki nieruchomości",
            title_a: "Sześć rynków,",
            title_highlight: "jeden doradca.",
            subtitle: "Kuratorowane doradztwo nieruchomościowe w Europie, Zatoce, Azji Południowo-Wschodniej i na Oceanie Indyjskim.",
            cta: "Umów konsultację",
            service_labels: {
                sales: "Sprzedaż",
                rentals: "Najem",
                cleaning: "Sprzątanie",
                maintenance: "Utrzymanie",
            },
            countries: {
                poland: { name: "Polska", tag: "Rynek macierzysty", blurb: "Butikowe apartamenty na krakowskiej Starówce, prestiżowe adresy w Warszawie i zabytkowe obiekty komercyjne — z pełną obsługą sprzątania i utrzymania każdej nieruchomości." },
                uae: { name: "Zjednoczone Emiraty Arabskie", tag: "Dubaj · Abu Zabi", blurb: "Rezydencje sięgające nieba i off-market wille w Dubaju, Palm Jumeirah i Abu Zabi — pozyskiwane dyskretnymi kanałami międzynarodowymi." },
                georgia: { name: "Gruzja", tag: "Tbilisi · Batumi", blurb: "Rosnący rynek nieruchomości mieszkaniowych i krótkoterminowych na wybrzeżu Morza Czarnego oraz w historycznych dzielnicach Tbilisi." },
                cyprus: { name: "Cypr Północny", tag: "Kyrenia · Famagusta · Edremit", blurb: "Rezydencje z widokiem na morze i inwestycje przy plaży — atrakcyjne ceny wejścia i lifestyle-owe zwroty." },
                bali: { name: "Bali", tag: "Canggu · Ubud · Bukit", blurb: "Designerskie wille i butikowe inwestycje w najbardziej pożądanych enklawach Bali — od surfingu po dżunglę." },
                maldives: { name: "Malediwy", tag: "Thulusdhoo", blurb: "Rezydencje na prywatnych wyspach i markowe inwestycje nad wodą w rynku definiowanym przez rzadkość i prestiż." },
            },
        },
        why: {
            eyebrow: "Dlaczego LuxeNova",
            title_a: "Detale,",
            title_highlight: "dopięte na ostatni guzik.",
            pillars: [
                { title: "Usługa Premium", desc: "Wyjątkowa uwaga dla każdego zapytania, każdego detalu." },
                { title: "Sprawdzona lokalna wiedza", desc: "Głębokie relacje w Polsce oraz na naszych sześciu rynkach międzynarodowych." },
                { title: "Spersonalizowane rozwiązania", desc: "Dopasowane do rodziny, firmy lub okazji." },
                { title: "Szybka komunikacja", desc: "Bezpośredni kontakt WhatsApp z dedykowanym doradcą." },
                { title: "Międzynarodowi klienci", desc: "Rozumiemy oczekiwania globalnej klienteli." },
                { title: "Luksusowe doświadczenie", desc: "Spokojny, przemyślany, redakcyjny standard — od początku do końca." },
            ],
        },
        contact: {
            eyebrow: "Kontakt",
            title_a: "Rozpocznij",
            title_highlight: "rozmowę.",
            subtitle: "Jeden punkt kontaktowy — odpowiadamy zazwyczaj w ciągu godziny, po angielsku lub polsku.",
            form_eyebrow: "Formularz zapytania",
            form_title: "Opowiedz nam o swoich planach.",
            form_subtitle: "Podziel się kilkoma szczegółami, a odpowiemy osobiście — nigdy ogólnym szablonem.",
            cards: { phone: "Telefon", whatsapp: "WhatsApp", instagram: "Instagram", facebook: "Facebook", email: "E-mail", website: "Strona www" },
            fields: { name: "Imię i nazwisko", email: "E-mail", phone: "Telefon", service: "Wybrana usługa", country: "Kraj / region zainteresowania", description: "Opis" },
            placeholders: {
                name: "Anna Kowalska",
                email: "ty@przyklad.com",
                phone: "+48 ...",
                service: "Wybierz usługę",
                country: "Wybierz kraj",
                description: "Kilka słów o Twoim zapytaniu — daty, lokalizacja, orientacyjny budżet.",
            },
            options: { property: "Nieruchomości", concierge: "Concierge", events: "Wydarzenia" },
            submit: "Wyślij zapytanie",
            submitting: "Wysyłam",
            disclaimer: "Wysyłając formularz, wyrażasz zgodę na kontakt ze strony LuxeNova.",
            open: "Otwórz",
            toast: {
                success_title: "Dziękujemy",
                success_body: "Otrzymaliśmy Twoje zapytanie — doradca LuxeNova skontaktuje się w ciągu godziny.",
                fill: "Wypełnij wszystkie wymagane pola.",
                rate_limit: "Osiągnięto limit zapytań. Napisz do nas na WhatsApp: +48 576 489 912.",
                error: "Coś poszło nie tak. Spróbuj przez WhatsApp.",
            },
        },
        footer: {
            tagline: "Nieruchomości · Concierge · Wydarzenia",
            discover: "Odkryj",
            rights: "Wszelkie prawa zastrzeżone.",
            crafted: "Stworzone w Krakowie",
            base: "Siedziby · Warszawa · Kraków, Polska",
        },
        booking: {
            eyebrow: "Konsultacja Online",
            title_a: "Zarezerwuj prywatną",
            title_highlight: "konsultację.",
            subtitle: "Umów bezpłatną 30-minutową konsultację online z doradcą LuxeNova — nieruchomości na sześciu rynkach lub concierge i wydarzenia w Polsce.",
            pick_date: "Wybierz datę",
            pick_slot: "Wybierz godzinę",
            loading_slots: "Sprawdzamy dostępność…",
            no_slots: "Brak wolnych terminów tego dnia — wybierz inny dzień.",
            video_note: "Konsultacje odbywają się online w formie wideorozmowy. Doradca potwierdzi spotkanie i prześle link mailem.",
            fields: {
                name: "Imię i nazwisko",
                email: "Email",
                phone: "Numer telefonu",
                type: "Rodzaj konsultacji",
                market: "Interesujący rynek",
                market_any: "Jeszcze nie wiem / kilka rynków",
                notes: "Uwagi",
            },
            placeholders: { notes: "Wszystko, co pomoże nam się przygotować — budżet, terminy, okazja…" },
            types: { property: "Nieruchomości", concierge: "Concierge", events: "Wydarzenia" },
            submit: "Zarezerwuj konsultację",
            submitting: "Rezerwuję…",
            select_hint: "Wybierz datę i godzinę, aby kontynuować.",
            disclaimer: "Bezpłatnie i bez zobowiązań. Rezerwując, wyrażasz zgodę na kontakt ze strony LuxeNova.",
            toast: {
                success_title: "Konsultacja zarezerwowana",
                success_body: "Sprawdź skrzynkę — doradca LuxeNova potwierdzi spotkanie i prześle link.",
                fill: "Podaj imię, email i wybierz godzinę.",
                taken: "Ten termin właśnie został zajęty — wybierz inną godzinę.",
                rate_limit: "Zbyt wiele prób. Napisz do nas na WhatsApp: +48 576 489 912.",
                error: "Coś poszło nie tak. Spróbuj ponownie lub napisz na WhatsApp.",
            },
        },
        chatbot: {
            title: "LuxeNova Concierge",
            status: "AI · Online",
            welcome:
                "Witamy w LuxeNova. Jestem Twoim AI concierge — zapytaj o nieruchomości na naszych sześciu rynkach (Polska, ZEA, Gruzja, Cypr Północny, Bali, Malediwy) lub o concierge i wydarzenia w Warszawie i Krakowie.",
            placeholder: "Zapytaj concierge…",
            suggestions: [
                "Pokaż nieruchomości w Dubaju",
                "Zaplanuj prywatną galę w Warszawie",
                "Pomóż mi przeprowadzić się do Krakowa",
            ],
            error: "Przepraszamy — linia concierge jest chwilowo niedostępna. Napisz na WhatsApp.",
        },
        blog: {
            nav_back: "← Wróć",
            title: "Dziennik LuxeNova",
            subtitle:
                "Redakcyjne treści o luksusowych nieruchomościach na sześciu rynkach, lifestylu concierge i wydarzeniach w Warszawie i Krakowie.",
            search_placeholder: "Szukaj artykułów…",
            all: "Wszystkie",
            read_more: "Czytaj artykuł →",
            read_time: "min czytania",
            empty: "Brak artykułów. Zajrzyj wkrótce.",
            published: "Opublikowano",
            by: "Autor:",
            back_home: "Powrót do LuxeNova",
        },
        lang: { en: "English", pl: "Polski" },
    },
};
